import { NgModule } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EmissionPlacePipe } from 'src/app/shared/pipes/emission-place.pipe';
import { ValidationClassDirective } from 'src/app/shared/validation/validation-class/validation-class.directive';

import { DateModule } from './date/date.module';
import { HttpUtilsService } from './http-utils/http-utils.service';
import { ImageModule } from './images/images.module';
import { NumberModule } from './number/number.module';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { DomService } from './services/dom.service';
import { ValidationMessageComponent } from './validation/validation-message/validation-message.component';
import { ValidationMessageHelperService } from './validation/validation-message/validation-message-helper.service';
import { FormsModule } from './forms/forms.module';
import { dateRangeConfig, DATE_RANGE_CONFIG } from './date/date-range/date-range.config';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CurrencyModule } from './currency/currency.module';
import { AccountTranslatePipe } from './account/account-translate.pipe';
import { InitialsPipe } from './pipes/initials.pipe';
import { SortBoxComponent } from './sort-box/sort-box.component';
import { TableComponent } from './table/table.component';
import { SwitcherComponent } from './components/switcher/switcher.component';
import { ShopLogoUrlPipe } from './pipes/shop-logo-url.pipe';
import { ContentContainerClassDirective } from './directives/content-container-class.directive';
import { SkeletonLoaderModule } from './components/skeleton-loader/skeleton-loader.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OrderByPipe } from './pipes/order-by.pipe';
import { UserBonusComponent } from './user-bonus/user-bonus.component';
import { UserInvitationComponent } from './user-invitation/user-invitation.component';
import { ListPipe } from './pipes/list.pipe';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TruncateTextPipe } from 'src/app/shared/pipes/truncate-text.pipe';
import { TextFieldBadgeComponent } from './components/text-field-badge/text-field-badge.component';
import { FormatTextFieldTypePipe } from './pipes/format-text-field-type.pipe';

@NgModule({
  imports: [
    FormsModule,
    TranslateModule,
    RouterModule,
    CommonModule,
    CurrencyModule,
    DateModule,
    NumberModule,
    InlineSVGModule,
    ImageModule,
    DragDropModule,
    SkeletonLoaderModule,
    SortBoxComponent,
    ShopLogoUrlPipe,
    ListPipe,
    NgbDropdownModule,
    NgbTooltipModule,
    TableComponent,
    OrderByPipe,
    FormatTextFieldTypePipe,
  ],
  exports: [
    ValidationMessageComponent,
    ValidationClassDirective,
    BreadcrumbComponent,
    CurrencyModule,
    DateModule,
    NumberModule,
    AccountTranslatePipe,
    InitialsPipe,
    SortBoxComponent,
    TableComponent,
    SwitcherComponent,
    ImageModule,
    ShopLogoUrlPipe,
    ContentContainerClassDirective,
    OrderByPipe,
    SafeHtmlPipe,
    EmissionPlacePipe,
    UserBonusComponent,
    UserInvitationComponent,
    TruncateTextPipe,
    FormatTextFieldTypePipe,
    TextFieldBadgeComponent,
  ],
  declarations: [
    ValidationMessageComponent,
    ValidationClassDirective,
    BreadcrumbComponent,
    AccountTranslatePipe,
    InitialsPipe,
    SwitcherComponent,
    ContentContainerClassDirective,
    SafeHtmlPipe,
    EmissionPlacePipe,
    UserBonusComponent,
    UserInvitationComponent,
    TruncateTextPipe,
    TextFieldBadgeComponent,
  ],
  providers: [
    HttpUtilsService,
    ValidationMessageHelperService,
    DomService,
    /**
     * @todo: Move to DateRangeModule
     */
    { provide: DATE_RANGE_CONFIG, useValue: dateRangeConfig },
  ],
})
export class SharedModule { }
